const fontSizes = {
    default: 16,
};

const colors = {
    blue: 'rgb(45,49,148)',
    white: '#fff',
    cyan: '#befffc',
    black: '#323232',
};

const breakpoints = [480, 768, 992, 1200, 1600];

const pageWidth = 1920;

export { colors, fontSizes, breakpoints, pageWidth };



// WEBPACK FOOTER //
// ./src/css/variables.js